import { combineReducers } from "redux";
import auth from "../views/Auth/reducers";
import cfop from "../views/Company/InfoCompany/Cfop/reducers";
import companies from "../views/reducers";
import config from "../views/Company/InfoCompany/Configuration/reducers";
import loading from "./api/reducer";
import icms from "../views/Company/Classify/Icms/reducers";
import importacao from "../views/Company/Document/HistoricoImportacao/reducers";
import products from "../views/Company/Classify/reducers";
import pisCofins from "../views/Company/Classify/PisCofins/reducers";
import recoveries from "../views/Recovery/reducers";
import results from "../views/Company/Result/reducers";
import signalr from "./ducks/signalr";
import upload from "../views/Company/Document/Upload/reducers";
import planilhas from "./reducers/planilhasReducer";
import termos from "./reducers/termosReducer";
import subvencoes from "./reducers/subvencoesReducer";
import terceiros from "./reducers/terceirosReducer";

const reducers = combineReducers({
  auth,
  cfop,
  companies,
  config,
  loading,
  icms,
  importacao,
  products,
  pisCofins,
  recoveries,
  results,
  signalr,
  upload,
  planilhas,
  termos,
  subvencoes,
  terceiros
});

export default reducers;
